var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVariety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#FDE0E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_648_51009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 9.1V7L16.877 11.123",
    stroke: "url(#paint0_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2201 18.8211C18.3799 18.8211 19.3201 17.8809 19.3201 16.7211C19.3201 15.5613 18.3799 14.6211 17.2201 14.6211C16.0603 14.6211 15.1201 15.5613 15.1201 16.7211C15.1201 17.8809 16.0603 18.8211 17.2201 18.8211Z",
    stroke: "url(#paint1_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2768 12.8797C12.4366 12.8797 13.3768 11.9395 13.3768 10.7797C13.3768 9.61989 12.4366 8.67969 11.2768 8.67969C10.117 8.67969 9.17676 9.61989 9.17676 10.7797C9.17676 11.9395 10.117 12.8797 11.2768 12.8797Z",
    stroke: "url(#paint2_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2455 15.8562C15.4053 15.8562 16.3455 14.916 16.3455 13.7562C16.3455 12.5965 15.4053 11.6562 14.2455 11.6562C13.0857 11.6562 12.1455 12.5965 12.1455 13.7562C12.1455 14.916 13.0857 15.8562 14.2455 15.8562Z",
    stroke: "url(#paint3_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3373 11.7938C16.4971 11.7938 17.4373 10.8535 17.4373 9.69375C17.4373 8.53395 16.4971 7.59375 15.3373 7.59375C14.1775 7.59375 13.2373 8.53395 13.2373 9.69375C13.2373 10.8535 14.1775 11.7938 15.3373 11.7938Z",
    stroke: "url(#paint4_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3051 14.7625C19.4649 14.7625 20.4051 13.8223 20.4051 12.6625C20.4051 11.5027 19.4649 10.5625 18.3051 10.5625C17.1453 10.5625 16.2051 11.5027 16.2051 12.6625C16.2051 13.8223 17.1453 14.7625 18.3051 14.7625Z",
    stroke: "url(#paint5_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1918 16.9422C11.3516 16.9422 12.2918 16.002 12.2918 14.8422C12.2918 13.6824 11.3516 12.7422 10.1918 12.7422C9.032 12.7422 8.0918 13.6824 8.0918 14.8422C8.0918 16.002 9.032 16.9422 10.1918 16.9422Z",
    stroke: "url(#paint6_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1596 19.907C14.3194 19.907 15.2596 18.9668 15.2596 17.807C15.2596 16.6472 14.3194 15.707 13.1596 15.707C11.9998 15.707 11.0596 16.6472 11.0596 17.807C11.0596 18.9668 11.9998 19.907 13.1596 19.907Z",
    stroke: "url(#paint7_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 21.0008C10.2598 21.0008 11.2 20.0606 11.2 18.9008C11.2 17.741 10.2598 16.8008 9.1 16.8008C7.9402 16.8008 7 17.741 7 18.9008C7 20.0606 7.9402 21.0008 9.1 21.0008Z",
    stroke: "url(#paint8_linear_648_51009)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_648_51009",
    x: 3,
    y: 3,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_648_51009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_648_51009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_648_51009",
    x1: 16.877,
    y1: 7,
    x2: 21.0704,
    y2: 7.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_648_51009",
    x1: 15.1201,
    y1: 14.6211,
    x2: 19.3918,
    y2: 14.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_648_51009",
    x1: 9.17676,
    y1: 8.67969,
    x2: 13.4485,
    y2: 8.75395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_648_51009",
    x1: 12.1455,
    y1: 11.6562,
    x2: 16.4172,
    y2: 11.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_648_51009",
    x1: 13.2373,
    y1: 7.59375,
    x2: 17.509,
    y2: 7.66801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_648_51009",
    x1: 16.2051,
    y1: 10.5625,
    x2: 20.4768,
    y2: 10.6368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_648_51009",
    x1: 8.0918,
    y1: 12.7422,
    x2: 12.3635,
    y2: 12.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_648_51009",
    x1: 11.0596,
    y1: 15.707,
    x2: 15.3313,
    y2: 15.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_648_51009",
    x1: 7,
    y1: 16.8008,
    x2: 11.2717,
    y2: 16.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariety);
export default __webpack_public_path__ + "static/media/Variety.9d035f7be7d52a03a6bca5e0df57bb0e.svg";
export { ForwardRef as ReactComponent };